// Kirim first-touch pembeli ke `record_order_attribution` (mig 4170) sesudah
// checkout sukses — fire-and-forget: RPC SECURITY DEFINER memverifikasi order
// milik pemanggil sendiri dan menstempel store dari barisnya; gagal (termasuk
// migrasi belum ter-apply) = pelacakan diam, checkout tak pernah terganggu.
//
// SENGAJA bukan kolom di `orders` yang diisi klien saat INSERT checkout:
// kolom baru pada insert membuat SELURUH checkout gagal bila kode tiba lebih
// dulu dari migrasinya — dan checkout adalah jalur uang.

import { createBrowserSupabase } from "@/lib/supabase/browser";
import { getClientStoreId } from "@/lib/supabase/storeContextClient";
import {
  STORE_FIRST_TOUCH_KEY,
  firstTouchStillValid,
  parseFirstTouch,
} from "@/lib/storeAttribution";

/** Laporkan atribusi satu order (berdasar first-touch localStorage, 30 hari). */
export function recordOrderAttribution(orderCode: string): void {
  try {
    if (typeof window === "undefined" || !orderCode) return;
    // FAIL-CLOSED multi-tenant: tanpa toko ter-resolusi, jangan kirim apa pun.
    const storeId = getClientStoreId();
    if (!storeId) return;
    const firstTouch = parseFirstTouch(
      localStorage.getItem(STORE_FIRST_TOUCH_KEY)
    );
    // Tanpa first-touch berlaku = order organik/langsung — memang tanpa baris.
    if (!firstTouchStillValid(firstTouch, Date.now()) || !firstTouch) return;
    const db = createBrowserSupabase();
    if (!db) return;
    // Thenable supabase: onFulfilled/onRejected, bukan .catch.
    db.rpc("record_order_attribution", {
      p_order_code: orderCode,
      p_referrer: firstTouch.referrerHost,
      p_utm_source: firstTouch.utmSource,
      p_utm_medium: firstTouch.utmMedium,
      p_utm_campaign: firstTouch.utmCampaign,
    }).then(
      () => undefined,
      () => undefined
    );
  } catch {
    /* pelacakan tak boleh mengganggu checkout */
  }
}
